import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MetaDataService } from '@shared/core';

@Component({
  selector: 'crm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  readonly matIconsNames: string[] = [
    'skype',
    'attachments-gray',
    'whatsapp-blue',
    'profile',
    'family',
    'communications',
    'appeals',
    'sequence',
    'phone',
    'email',
    'facebook',
    'odnoklassniki',
    'telegram',
    'vkontakte',
    'slack',
    'vimbot',
  ]; // name should be the same with name in assets/icons

  constructor(private metaService: MetaDataService, matIconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    this.matIconsNames.forEach(iconName => {
      matIconRegistry.addSvgIcon(iconName, sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${iconName}.svg`));
    });
  }

  ngOnInit(): void {
    this.metaService.setTitle();
  }
}
